var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _g2, _g3, _path8, _path9, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnimated = function SvgAnimated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1794,
    height: 578,
    fill: "none",
    viewBox: "0 0 1794 578"
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_8824_8115)",
    d: "M233.503 488.85c-30.075 35.267-64.379 34.444-75.284.202s7.602-89.382 38.94-124.937c18.004-20.428 36.602-29.411 50.926-26.801 4.669.851 12.84 5.373 16.434 8.727 4.525 4.221 4.101 8 6.273 16.189 9.162 34.552-7.517 91.596-37.289 126.62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial_8824_8115)",
    d: "M237.886 488.354c-29.859 35.296-61.61 37.773-71.601 5.534s7.4-87.507 38.49-123.144 63.309-38.16 71.601-5.535-8.932 88.097-38.49 123.145"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_8824_8115)",
    d: "M237.431 476.775c23.967-28.11 38.36-72.24 32.153-97.971-1.946-8.067-5.806-13.369-10.967-15.967-10.618-9.062-29.807-1.249-48.45 21.769-18.384 22.699-30.531 53.556-31.682 77.399-.454 7.381.119 14.193 1.856 20.026 1.304 4.382 3.136 7.937 5.401 10.677 10.863 13.143 31.656 7.495 51.689-15.933",
    opacity: 0.17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_8824_8115)",
    d: "M236.936 476.374c-24.209 28.311-49.526 30.659-57.09 5.255s6.958-69.376 32.152-97.971 50.885-30.986 57.091-5.256c6.207 25.731-8.185 69.861-32.153 97.972"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8824_8115",
    width: 116,
    height: 175,
    x: 163,
    y: 342,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M237.885 488.354c-29.858 35.297-61.61 37.773-71.601 5.534s7.401-87.507 38.491-123.143c31.09-35.637 63.31-38.16 71.602-5.535s-8.933 88.096-38.492 123.144"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8824_8115)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_radial_8824_8115)",
    d: "m275.817 418.364-12.908 11.938-6.044 1.344-66.909 62.524-.027 2.404-26.984 26.175-27.656-51.02 128-61.057 5.281-.39 11.706-5.397z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_radial_8824_8115)",
    d: "m277.465 400.731-8.61 3.28-5.239.49-129.592 50.885 3.342-24.007 127.179-32.582 4.809-.203 18.477-4.59z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_8824_8115)",
    d: "M235.318 471.004c-22.997 29.211-47.485 33.617-55.221 9.896s5.627-67.129 29.574-96.697 48.795-34.046 55.221-9.896-6.808 67.698-29.574 96.697"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_8824_8115)",
    d: "M167.544 442.601s-2.687-.177-4.855-1.346-3.818-3.33-3.818-3.33 2.096-8.193 3.192-11.503 2.874-8.162 2.874-8.162 1.904 1.751 4.227 2.698 5.065 1.09 5.065 1.09-1.66 4.379-3.369 9.473c-1.708 5.093-3.316 11.08-3.316 11.08",
    opacity: 0.26
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8824_8115)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_8824_8115)",
    d: "m214.705 432.506 9.881-2.548a.89.89 0 0 1 .674.05l-12.817 25.956a.96.96 0 0 1-.454-.506l-3.984-9.386c-.116-.282-.057-.735.151-1.156l5.719-11.581c.211-.428.535-.75.83-.829"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8824_8115)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_8824_8115)",
    d: "m220.833 408.911 4.933-1.402-3.923 7.943 5.489-1.519 3.886-7.869 4.699-1.326a.52.52 0 0 1 .375.018l-8.881 17.986a1.02 1.02 0 0 0-.714-.044l-13.837 3.84c-.636.177-.86-.665-.421-1.554l7.488-15.164c.224-.463.576-.814.906-.909"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_8824_8115)",
    d: "m226.154 430.512 3.964 9.392c.115.283.055.735-.154 1.156l-5.748 11.571c-.212.428-.533.742-.828.821l-9.892 2.532a.95.95 0 0 1-.67-.05L225.708 430c.201.117.358.297.446.512"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear_8824_8115)",
    d: "m237.193 404.938 1.796 4.537-3.906 7.864 2.118 5.279 3.939-7.93 1.877 4.769c.125.32.059.812-.166 1.266l-7.527 15.152c-.441.889-1.251 1.22-1.492.609l-5.339-13.321a1 1 0 0 0-.469-.54l8.927-17.971c.114.062.2.164.242.286"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear_8824_8115)",
    d: "M259.912 58.684c9.113-5.818 16.71-3.297 16.809 5.086.1 8.382-7.787 19.423-17.201 25.22-5.41 3.33-10.171 4.067-13.189 2.508-.983-.508-2.498-2.074-3.071-3.067-.722-1.25-.37-2.064-.296-4.04.31-8.332 7.919-19.922 16.948-25.707"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_radial_8824_8115)",
    d: "M258.9 58.496c9.067-5.84 16.32-4.228 16.352 3.645.032 7.874-7.615 19.019-16.98 24.85s-16.725 4.2-16.351-3.644c.373-7.844 7.996-19.046 16.979-24.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear_8824_8115)",
    d: "M258.213 61.11c-7.263 4.638-13.482 13.503-13.85 19.666-.116 1.933.384 3.379 1.358 4.31 1.751 2.746 6.565 2.31 12.293-1.555 5.648-3.811 10.461-9.868 12.343-15.108.604-1.616.941-3.175.951-4.595.007-1.066-.159-1.984-.478-2.75-1.528-3.672-6.551-3.83-12.617.032",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear_8824_8115)",
    d: "M258.295 61.234c7.331-4.667 13.139-3.465 13.096 2.718-.044 6.183-6.281 15.003-13.85 19.666-7.57 4.663-13.464 3.445-13.096-2.718s6.588-15.028 13.85-19.666"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_radial_8824_8115)",
    d: "m245.668 71.526 3.693-1.784 1.44.112 19.189-9.389.169-.534 7.805-4.001 2.692 13.267-32.717 4.899-1.205-.273-2.979.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint17_radial_8824_8115)",
    d: "m244.099 75.348 2.144-.146 1.202.248 32.38-2.52-2.382 5.128-30.594-1.399-1.087-.282-4.435-.235z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint18_linear_8824_8115)",
    d: "M258.291 62.542c7.121-4.95 12.885-4.264 12.994 1.555.109 5.82-5.83 14.593-13.188 19.558-7.357 4.965-13.206 4.27-12.994-1.555.212-5.826 6.132-14.64 13.188-19.558"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint19_linear_8824_8115)",
    d: "M271.475 73.498s.588.222.992.63c.404.41.625 1.004.625 1.004s-1.026 1.685-1.497 2.349c-.47.663-1.197 1.625-1.197 1.625s-.305-.52-.759-.89-1.056-.589-1.056-.589.669-.864 1.397-1.883c.729-1.02 1.495-2.246 1.495-2.246",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint20_linear_8824_8115)",
    d: "m260.266 72.536-2.378-.106a.2.2 0 0 1-.147-.056l4.628-4.918c.039.038.063.09.067.144l.249 2.366c.007.07-.037.167-.112.247l-2.065 2.194c-.077.081-.171.131-.242.129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint21_linear_8824_8115)",
    d: "m257.291 77.382-1.196-.023 1.416-1.505-1.328-.035-1.403 1.49-1.139-.024a.12.12 0 0 1-.082-.03l3.207-3.407a.24.24 0 0 0 .156.058l3.349.087c.154.004.146.207-.012.375l-2.704 2.873c-.082.088-.184.142-.264.141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint22_linear_8824_8115)",
    d: "m257.576 72.2-.245-2.365c-.006-.071.038-.168.113-.248l2.071-2.19c.077-.08.17-.129.241-.126l2.379.109a.22.22 0 0 1 .147.057l-4.642 4.908a.24.24 0 0 1-.064-.145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint23_linear_8824_8115)",
    d: "m253.37 77.153-.092-1.134 1.408-1.489-.113-1.322-1.419 1.501-.094-1.192c-.006-.08.042-.185.123-.27l2.712-2.868c.159-.169.362-.187.375-.035l.283 3.336a.23.23 0 0 0 .068.153l-3.217 3.4a.12.12 0 0 1-.034-.08"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint24_linear_8824_8115)",
    d: "M636.697 386.379c16.366 15.519 15.086 32.167-1.832 36.588-16.919 4.421-43.238-5.986-59.712-22.126-9.465-9.273-13.353-18.54-11.717-25.433.533-2.248 2.94-6.102 4.662-7.763 2.167-2.09 3.992-1.787 8.027-2.632 17.025-3.567 44.316 6.001 60.572 21.366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint25_radial_8824_8115)",
    d: "M636.568 384.237c16.386 15.414 16.775 30.907.853 34.935s-42.332-5.84-58.852-21.861-16.919-31.743-.853-34.936c16.066-3.192 42.58 6.6 58.852 21.862"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint26_linear_8824_8115)",
    d: "M630.931 384.161c-13.046-12.367-34.121-20.493-46.783-18.137-3.97.739-6.645 2.479-8.04 4.92-4.676 4.927-1.372 14.452 9.336 24.102 10.558 9.515 25.241 16.209 36.798 17.379 3.574.41 6.899.307 9.778-.388 2.163-.521 3.938-1.32 5.327-2.35 6.665-4.942 4.454-15.191-6.416-25.526",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint27_linear_8824_8115)",
    d: "M630.723 384.391c13.136 12.49 13.628 24.853 1.089 27.877s-33.533-5.161-46.782-18.136c-13.249-12.976-13.752-25.521-1.09-27.877 12.662-2.357 33.737 5.769 46.783 18.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint28_radial_8824_8115)",
    d: "m603.531 364.01 5.47 6.579.498 2.971 28.667 34.117 1.167.074 12.027 13.784-25.501 12.13-26.387-63.764-.054-2.576-2.322-5.827z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint29_radial_8824_8115)",
    d: "m595.005 362.757 1.373 4.268.104 2.559 21.403 64.277-11.58-2.24-12.571-62.635.025-2.342-1.757-9.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint30_linear_8824_8115)",
    d: "M628.072 385.04c13.605 11.924 15.117 23.936 3.392 27.087s-32.475-4.456-46.229-16.85-15.292-24.585-3.393-27.088 32.722 5.044 46.23 16.851"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint31_linear_8824_8115)",
    d: "M612.532 417.245s-.155 1.301-.779 2.325c-.623 1.023-1.716 1.769-1.716 1.769s-3.927-1.228-5.508-1.846-3.892-1.606-3.892-1.606.9-.88 1.42-1.984.659-2.434.659-2.434 2.086.919 4.517 1.88 5.299 1.896 5.299 1.896",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint32_linear_8824_8115)",
    d: "m608.836 394.069-.984-4.867a.43.43 0 0 1 .041-.326l12.284 6.894a.47.47 0 0 1-.257.207l-4.664 1.695c-.14.05-.358.009-.558-.103l-5.48-3.075c-.203-.114-.351-.28-.382-.425"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint33_linear_8824_8115)",
    d: "m597.527 390.486-.554-2.433 3.759 2.11-.597-2.706-3.725-2.091-.524-2.317a.26.26 0 0 1 .019-.182l8.512 4.778a.5.5 0 0 0-.04.345l1.511 6.823c.07.313-.344.4-.765.164l-7.177-4.027c-.219-.121-.381-.301-.419-.464"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint34_linear_8824_8115)",
    d: "m608.161 388.454 4.665-1.685c.141-.049.359-.008.558.104l5.475 3.09c.203.114.347.278.378.424l.977 4.871a.46.46 0 0 1-.042.325l-12.271-6.925a.5.5 0 0 1 .26-.204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint35_linear_8824_8115)",
    d: "m596.017 382.434 2.251-.756 3.72 2.1 2.62-.894-3.752-2.117 2.365-.79c.159-.053.396-.008.611.113l7.17 4.046c.42.237.561.639.258.741l-6.61 2.253a.48.48 0 0 0-.275.214l-8.504-4.799a.25.25 0 0 1 .146-.111"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint36_linear_8824_8115)",
    d: "M1717.27 82.38c18.35-3.541 28.95 5.352 23.77 18.883-5.19 13.532-24.89 26.246-43.71 29.56-10.82 1.904-18.94.054-22.79-4.373-1.26-1.444-2.7-4.924-2.98-6.886-.37-2.468.72-3.552 2.09-6.678 5.81-13.191 25.42-26.964 43.62-30.506"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint37_radial_8824_8115)",
    d: "M1715.76 81.434c18.29-3.605 28.92 3.605 23.95 16.276-4.96 12.671-24.35 25.706-43.12 29.108-18.76 3.402-29.54-3.911-23.94-16.276 5.59-12.365 24.98-25.506 43.11-29.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint38_linear_8824_8115)",
    d: "M1712.99 85.196c-14.62 2.824-30.26 13.104-34.78 22.772-1.42 3.031-1.54 5.673-.57 7.79 1.07 5.527 9.08 7.895 20.74 5.336 11.51-2.524 23.1-9.189 29.46-16.41 2.01-2.211 3.54-4.501 4.46-6.776.69-1.709 1.01-3.29.99-4.723-.12-6.874-8.09-10.328-20.3-7.99",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint39_linear_8824_8115)",
    d: "M1713.05 85.447c14.75-2.826 23.32 2.805 19.3 12.712-4.01 9.907-19.65 20.105-34.78 22.773s-23.83-3.045-19.31-12.713 20.16-19.948 34.79-22.772"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint40_radial_8824_8115)",
    d: "m1686.2 93.937 7.07-.512 2.24 1.097 36.82-2.858.61-.75 15.09-1.456-4.13 23.034-55.69-12.979-1.76-1.206-5.05-1.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint41_radial_8824_8115)",
    d: "m1681.24 99.078 3.54 1.133 1.77 1.164 53.64 16.584-7.1 6.722-48.26-21.743-1.57-1.146-6.98-3.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint42_linear_8824_8115)",
    d: "M1712.2 87.546c14.6-3.415 23.42 1.36 19.89 10.78s-18.66 19.732-33.65 23.02-23.94-1.555-19.89-10.78c4.06-9.225 19.18-19.614 33.65-23.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint43_linear_8824_8115)",
    d: "M1726.41 113.55s.8.732 1.19 1.646.36 2.01.36 2.01-2.72 2.054-3.9 2.821-2.96 1.848-2.96 1.848-.16-1.031-.65-1.914-1.32-1.618-1.32-1.618 1.62-.962 3.44-2.137c1.83-1.174 3.84-2.656 3.84-2.656",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint44_linear_8824_8115)",
    d: "m1709.01 104.862-3.75-1.684a.36.36 0 0 1-.2-.186l10.57-4.951a.37.37 0 0 1 .01.273l-1.11 3.96c-.03.118-.16.246-.33.326l-4.72 2.21c-.17.081-.36.101-.47.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint45_linear_8824_8115)",
    d: "m1701.14 110.753-1.91-.8 3.24-1.515-2.11-.903-3.21 1.501-1.81-.765a.2.2 0 0 1-.11-.1l7.32-3.431c.05.088.12.157.21.194l5.33 2.272c.24.104.1.426-.26.596l-6.17 2.892c-.19.09-.39.112-.52.059"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint46_linear_8824_8115)",
    d: "m1704.9 102.608 1.12-3.956c.03-.118.16-.246.34-.326l4.72-2.198c.17-.082.35-.1.47-.05l3.75 1.691c.09.035.16.101.2.185l-10.59 4.928a.5.5 0 0 1-.01-.274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint47_linear_8824_8115)",
    d: "m1694.99 107.887.57-1.882 3.21-1.494.66-2.196-3.23 1.507.61-1.975c.04-.132.18-.271.37-.357l6.18-2.88c.37-.168.7-.069.63.184l-1.67 5.541a.36.36 0 0 0 .01.288l-7.34 3.415a.2.2 0 0 1 0-.151"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint48_linear_8824_8115)",
    d: "M1172.14 86.714c-29.54-27.548-27.49-57.378 2.74-65.542s77.51 10.083 107.25 38.741c17.08 16.465 24.18 33.002 21.35 45.37-.92 4.031-5.17 10.968-8.23 13.967-3.85 3.775-7.13 3.26-14.34 4.832-30.43 6.636-79.44-10.095-108.77-37.368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint49_radial_8824_8115)",
    d: "M1172.4 90.547c-29.57-27.36-30.49-55.095-2.04-62.542s75.88 9.835 105.7 38.28c29.82 28.446 30.76 56.59 2.04 62.543s-76.34-11.192-105.7-38.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint50_linear_8824_8115)",
    d: "M1182.49 90.6c23.54 21.954 61.4 36.193 84.04 31.788 7.1-1.381 11.86-4.535 14.32-8.927 8.3-8.891 2.25-25.898-17.07-43.02-19.04-16.883-45.43-28.652-66.14-30.579-6.41-.681-12.36-.447-17.51.839-3.86.965-7.03 2.422-9.5 4.287-11.86 8.947-7.75 27.266 11.86 45.613",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint51_linear_8824_8115)",
    d: "M1182.86 90.185c-23.7-22.171-24.76-44.3-2.36-49.9 22.41-5.6 60.12 8.748 84.04 31.788 23.91 23.04 25 45.495 2.36 49.9s-60.5-9.835-84.04-31.788"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint52_radial_8824_8115)",
    d: "m1231.85 126.28-9.89-11.7-.93-5.313-51.84-60.668-2.09-.116-21.74-24.505 45.49-22.095 48.18 113.79.14 4.612 4.24 10.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint53_radial_8824_8115)",
    d: "m1247.14 128.397-2.52-7.621-.23-4.58-39.27-114.78 20.77 3.84 23.43 111.97-.01 4.194 3.28 16.262z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint54_linear_8824_8115)",
    d: "M1187.6 88.985c-24.54-21.152-27.42-42.639-6.47-48.453s58.21 7.5 83.02 29.493 27.75 43.796 6.48 48.453-58.67-8.551-83.03-29.493"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint55_linear_8824_8115)",
    d: "M1214.95 31.09s.26-2.332 1.36-4.174 3.05-3.194 3.05-3.194 7.05 2.142 9.89 3.225 6.99 2.818 6.99 2.818-1.6 1.59-2.51 3.575-1.15 4.366-1.15 4.366-3.74-1.615-8.11-3.3-9.52-3.316-9.52-3.316",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint56_linear_8824_8115)",
    d: "m1221.91 72.535 1.84 8.7c.05.196.03.407-.07.585l-22.1-12.164c.1-.177.26-.31.46-.376l8.32-3.103c.25-.09.64-.022 1 .176l9.86 5.427c.37.2.63.495.69.754"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint57_linear_8824_8115)",
    d: "m1242.21 78.783 1.03 4.349-6.76-3.723 1.11 4.837 6.7 3.688.97 4.142c.03.109.02.225-.03.326l-15.31-8.43a.88.88 0 0 0 .06-.619l-2.8-12.194c-.13-.56.61-.723 1.37-.306l12.91 7.107c.39.213.68.532.75.823"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint58_linear_8824_8115)",
    d: "m1223.2 82.578-8.33 3.086c-.25.09-.64.02-1-.178l-9.85-5.452c-.36-.202-.62-.493-.68-.754l-1.82-8.708a.84.84 0 0 1 .07-.582l22.08 12.22a.94.94 0 0 1-.47.368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint59_linear_8824_8115)",
    d: "m1245.04 93.18-4.02 1.386-6.7-3.705-4.67 1.64 6.75 3.736-4.23 1.449c-.28.096-.71.02-1.09-.194l-12.9-7.14c-.76-.418-1.01-1.136-.47-1.322l11.8-4.131a.85.85 0 0 0 .49-.387l15.3 8.468a.45.45 0 0 1-.26.2"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint60_linear_8824_8115)",
    d: "M1455.06 488.627c-11.28-14.279-8.34-27.425 5.68-29.003 14.02-1.579 33.84 9.766 45.13 24.554 6.49 8.495 8.52 16.343 6.42 21.659-.68 1.733-3.05 4.533-4.61 5.66-1.98 1.419-3.4.967-6.72 1.177-14 .884-34.69-9.904-45.9-24.047"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint61_radial_8824_8115)",
    d: "M1454.92 490.352c-11.31-14.197-9.83-26.613 3.35-27.993 13.17-1.38 33.12 9.546 44.47 24.244 11.34 14.698 9.84 27.297-3.35 27.993-13.2.696-33.24-10.181-44.47-24.244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint62_linear_8824_8115)",
    d: "M1459.41 491.063c8.99 11.38 24.88 20.298 35.26 19.877 3.26-.132 5.59-1.212 6.99-3.001 4.3-3.394 2.76-11.381-4.67-20.321-7.34-8.815-18.29-15.853-27.38-18.121-2.81-.74-5.48-1.041-7.86-.818-1.78.167-3.29.6-4.52 1.263-5.89 3.177-5.31 11.615 2.18 21.121",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint63_linear_8824_8115)",
    d: "M1459.6 490.904c-9.05-11.488-8.01-21.416 2.35-22.385s26.18 7.988 35.26 19.877 8.04 21.964-2.34 22.385c-10.39.421-26.28-8.498-35.27-19.877"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint64_radial_8824_8115)",
    d: "m1478.96 510.313-3.61-5.884-.05-2.43-18.96-30.547-.92-.194-8.01-12.393 21.76-6.745 13.71 53.958-.25 2.063 1.18 4.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint65_radial_8824_8115)",
    d: "m1485.63 512.297-.61-3.566.22-2.055-9.68-53.792 8.99 3.123 2.81 51.463-.29 1.867.35 7.466z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint66_linear_8824_8115)",
    d: "M1461.79 490.691c-9.48-11.09-9.31-20.856.42-22.019 9.72-1.164 25.42 7.303 34.97 18.786s9.37 21.393-.42 22.02-25.54-7.802-34.97-18.787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint67_linear_8824_8115)",
    d: "M1477.92 466.769s.27-1.021.89-1.767c.61-.745 1.57-1.215 1.57-1.215s2.99 1.434 4.19 2.109c1.19.676 2.92 1.731 2.92 1.731s-.82.6-1.36 1.422c-.55.822-.81 1.866-.81 1.866s-1.56-.974-3.39-2.022a88 88 0 0 0-4.01-2.124",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint68_linear_8824_8115)",
    d: "m1478.19 485.7.23 4a.4.4 0 0 1-.07.256l-9.01-6.922c.05-.072.13-.12.22-.136l3.92-.815c.12-.024.29.034.44.146l4.02 3.088c.15.114.25.263.25.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint69_linear_8824_8115)",
    d: "m1486.81 489.865.16 2.007-2.76-2.118.17 2.229 2.73 2.099.15 1.911c.01.05 0 .101-.03.143l-6.25-4.797a.38.38 0 0 0 .07-.271l-.42-5.622c-.02-.258.33-.28.63-.043l5.27 4.044c.16.121.27.284.28.418"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint70_linear_8824_8115)",
    d: "m1478.09 490.261-3.92.808c-.12.023-.29-.035-.44-.148l-4.01-3.098c-.15-.115-.25-.263-.26-.382l-.21-4.003a.34.34 0 0 1 .07-.254l9 6.945a.4.4 0 0 1-.23.132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint71_linear_8824_8115)",
    d: "m1487.09 496.469-1.89.344-2.73-2.106-2.19.412 2.75 2.123-1.98.358c-.13.024-.32-.039-.47-.161l-5.26-4.057c-.31-.238-.37-.575-.12-.622l5.54-1.036a.4.4 0 0 0 .24-.139l6.24 4.812a.22.22 0 0 1-.13.072"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#408B5F",
    d: "M1483.52 265.153q.12.397-.21 1.009l-4.61 8.391 4.3 8.564c.05.115.09.234.13.356.07.226.07.471 0 .699-.04.105-.1.2-.18.275a.65.65 0 0 1-.29.155c-.26.07-.53.071-.79.002l-9.41-1.799-6.82 6.731c-.18.198-.4.349-.65.437a.682.682 0 0 1-.65-.089 1.1 1.1 0 0 1-.39-.584 2.4 2.4 0 0 1-.07-.372l-1.19-9.509-8.52-4.396q-.6-.351-.72-.731c-.14-.445.12-.825.76-1.139l8.67-4.076 1.57-9.459q.12-.845.66-1.01.54-.164 1.11.472l6.56 6.987 9.48-1.438q1.065-.144 1.26.524"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46AC61",
    d: "M1482.66 284.605c-.12.035-.24.053-.37.052a2 2 0 0 1-.42-.05l-9.41-1.799-.01.007-7.35-24.203.01-.002a.8.8 0 0 1 .27-.032c.1.006.19.029.28.067.1.044.19.101.28.168.1.081.19.171.28.269l6.56 6.987 9.48-1.438c.15-.024.31-.031.47-.022.13.007.26.034.37.08q.15.061.27.182a.75.75 0 0 1 .18.495c.01.08 0 .161-.02.239-.04.196-.12.384-.22.559l-4.61 8.391 4.3 8.564c.05.116.09.234.13.356q.045.178.06.364 0 .172-.06.335a.6.6 0 0 1-.17.268.8.8 0 0 1-.3.163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1464.9 258.714 6.95 24.704.6-.611.7.145-7.87-24.371a.6.6 0 0 0-.23.058c-.1.053-.15.075-.15.075",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1482.71 284.592c-.12.035-.24.053-.37.052a2 2 0 0 1-.42-.05l-9.41-1.799-6.82 6.731a2 2 0 0 1-.33.279c-.1.068-.21.121-.32.158a.8.8 0 0 1-.35.034.65.65 0 0 1-.3-.124 1 1 0 0 1-.23-.249 1.4 1.4 0 0 1-.16-.335 5 5 0 0 1-.07-.373l-1.19-9.508-8.52-4.397a3 3 0 0 1-.35-.235 2 2 0 0 1-.23-.241l29.96-9.108c0 .116-.03.229-.06.338-.05.134-.11.263-.17.387l-4.62 8.392 4.3 8.563c.05.116.09.235.13.356q.06.178.06.365c0 .113-.02.227-.06.334a.6.6 0 0 1-.17.268.8.8 0 0 1-.3.162",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint72_linear_8824_8115)",
    d: "m1462.7 279.27 5.91-9.294-15.15 4.604q.57.346 1.17.628c.28.093 8.07 4.062 8.07 4.062",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint73_linear_8824_8115)",
    d: "m1478.67 274.411-10.06-4.428 15.12-4.597q-.285.605-.63 1.175c-.17.229-4.43 7.85-4.43 7.85",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint74_linear_8824_8115)",
    d: "m1462.93 269.133 5.56.703-3.39-11.152s-.3-.082-.43.308c-.13.391-1.74 10.141-1.74 10.141",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint75_linear_8824_8115)",
    d: "m1472.75 266.165-4.25 3.697-3.4-11.203s.21-.241.53.014c.33.255 7.12 7.492 7.12 7.492",
    opacity: 0.18
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#408B5F",
    d: "M578.252 68.42q-.17.381-.818.627l-8.982 3.322-2.356 9.288q-.056.182-.136.354a1.1 1.1 0 0 1-.454.532.66.66 0 0 1-.638.016 1.5 1.5 0 0 1-.598-.515l-5.936-7.52-9.56.625a1.6 1.6 0 0 1-.783-.1.68.68 0 0 1-.432-.492 1.12 1.12 0 0 1 .091-.693q.084-.171.188-.33l5.324-7.968-3.563-8.902q-.223-.658-.063-1.02.285-.639 1.32-.364l9.224 2.595 7.376-6.124q.644-.562 1.161-.331.518.23.531 1.084l.388 9.579 8.103 5.114q.897.586.613 1.224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46AC61",
    d: "M564.866 82.56a1.3 1.3 0 0 1-.313-.201 2 2 0 0 1-.285-.313l-5.935-7.52h-.011l10.285-23.11.009.005a.77.77 0 0 1 .391.386 1.3 1.3 0 0 1 .102.31q.036.192.038.388l.388 9.579 8.103 5.114q.202.13.375.296.137.133.227.303a.7.7 0 0 1 .08.31.77.77 0 0 1-.183.497 1 1 0 0 1-.175.164 2.1 2.1 0 0 1-.529.282l-8.982 3.321-2.356 9.289q-.056.18-.136.353-.074.17-.194.314-.111.13-.26.218a.63.63 0 0 1-.306.089.8.8 0 0 1-.333-.073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M568.392 51.364 557.474 74.59l.848-.074.44.573 10.006-23.575a.6.6 0 0 0-.217-.11c-.107-.023-.159-.04-.159-.04",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M564.914 82.585a1.3 1.3 0 0 1-.313-.202 1.8 1.8 0 0 1-.284-.313l-5.936-7.52-9.561.625a2 2 0 0 1-.432-.005 1.3 1.3 0 0 1-.351-.094.8.8 0 0 1-.288-.205.63.63 0 0 1-.143-.288 1 1 0 0 1-.012-.34q.027-.184.103-.354.084-.171.188-.33l5.324-7.967-3.563-8.902a3 3 0 0 1-.106-.403 1.4 1.4 0 0 1-.022-.338l28.616 12.733a1.3 1.3 0 0 1-.273.21 2.5 2.5 0 0 1-.38.182l-8.983 3.322-2.356 9.288q-.056.181-.136.354-.074.17-.194.314a1 1 0 0 1-.26.218.64.64 0 0 1-.306.089.8.8 0 0 1-.332-.074",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint76_linear_8824_8115)",
    d: "m553.269 65.461 10.549-3.158-14.464-6.436q.205.635.478 1.244c.147.25 3.437 8.35 3.437 8.35",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint77_linear_8824_8115)",
    d: "m568.523 72.243-4.708-9.935 14.442 6.426q-.608.273-1.243.477c-.284.058-8.491 3.032-8.491 3.032",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint78_linear_8824_8115)",
    d: "m560.078 57.948 3.747 4.174 4.739-10.648s-.178-.263-.53-.051-7.956 6.525-7.956 6.525",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint79_linear_8824_8115)",
    d: "m569.449 62.136-5.636.011 4.761-10.697s.317-.045.395.36c.079.406.48 10.326.48 10.326",
    opacity: 0.18
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#408B5F",
    d: "M59.622 243.91q.507.599.397 1.906l-1.71 18.023 13.887 11.629q.262.244.49.522c.303.335.49.759.534 1.209a1.26 1.26 0 0 1-.497 1.1 2.9 2.9 0 0 1-1.366.596l-17.676 3.941-6.777 16.796c-.162.478-.441.908-.811 1.251a1.3 1.3 0 0 1-1.193.331 2.1 2.1 0 0 1-1.106-.723 6 6 0 0 1-.408-.591l-9.203-15.602-18.083-1.233q-1.304-.157-1.79-.73-.854-1.007.464-2.546l11.985-13.581-4.38-17.585q-.43-1.555.387-2.248.818-.693 2.282-.016l16.632 7.196 15.356-9.605q1.733-1.048 2.587-.041z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46AC61",
    d: "M72.725 278.304a2.4 2.4 0 0 1-.6.368 3.5 3.5 0 0 1-.766.228l-17.676 3.941-.007.019-30.923-36.471.014-.011c.132-.113.284-.201.447-.26.17-.06.35-.09.531-.091q.311.002.611.082.358.096.692.253l16.633 7.196 15.356-9.605a4.5 4.5 0 0 1 .811-.396c.225-.083.462-.13.702-.139a1.4 1.4 0 0 1 .592.118c.186.089.35.217.482.375q.132.157.215.344.093.209.138.433c.069.373.084.754.045 1.131l-1.71 18.023 13.887 11.63q.262.243.49.521.23.267.375.588c.088.197.141.407.159.621.017.203-.017.408-.1.594a1.46 1.46 0 0 1-.398.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.487 246.714 30.601 37.642.57-1.505 1.337-.279-31.945-36.376c-.139.067-.264.162-.366.278-.126.164-.197.24-.197.24",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72.806 278.242a2.4 2.4 0 0 1-.6.368 3.5 3.5 0 0 1-.766.228l-17.676 3.941-6.777 16.796q-.144.384-.364.73a2.4 2.4 0 0 1-.447.521c-.17.149-.369.259-.585.323a1.2 1.2 0 0 1-.608.006 1.9 1.9 0 0 1-.587-.257 2.5 2.5 0 0 1-.52-.466 6 6 0 0 1-.408-.591l-9.202-15.602-18.084-1.232q-.392-.045-.773-.15a2.8 2.8 0 0 1-.593-.24l45.156-38.293q.108.31.134.638.032.398-.004.797l-1.709 18.024 13.887 11.629q.262.244.49.522.23.267.375.588c.088.196.141.406.159.621.017.203-.017.407-.1.594a1.5 1.5 0 0 1-.398.505",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint80_linear_8824_8115)",
    d: "m34.092 284.031 3.273-20.558-22.825 19.356q1.25.173 2.512.207c.547-.046 17.04.995 17.04.995",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint81_linear_8824_8115)",
    d: "m58.153 263.613-20.781-.13 22.789-19.325a23 23 0 0 1-.208 2.509c-.134.53-1.8 16.946-1.8 16.946",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint82_linear_8824_8115)",
    d: "m26.882 266.272 10.181-2.958-14.248-16.803s-.594.086-.522.86 4.589 18.901 4.589 18.901",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint83_linear_8824_8115)",
    d: "m41.699 253.747-4.603 9.607-14.314-16.882s.183-.575.939-.377c.755.198 17.978 7.652 17.978 7.652",
    opacity: 0.18
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8824_8115",
    x1: 284.69,
    x2: 147.349,
    y1: 371.031,
    y2: 480.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#098A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#33F89A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#05BF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8824_8115",
    x1: 278.65,
    x2: 170.458,
    y1: 384.805,
    y2: 474.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8824_8115",
    x1: 278.766,
    x2: 170.574,
    y1: 385.142,
    y2: 474.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#16A460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FFC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8824_8115",
    x1: 274.374,
    x2: 171.015,
    y1: 379.948,
    y2: 474.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FF6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18CF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8824_8115",
    x1: 212.963,
    x2: 146.332,
    y1: 431.18,
    y2: 413.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8824_8115",
    x1: 221.342,
    x2: 208.549,
    y1: 428.077,
    y2: 454.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8824_8115",
    x1: 230.716,
    x2: 217.443,
    y1: 402.009,
    y2: 428.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8824_8115",
    x1: 229.62,
    x2: 223.053,
    y1: 431.939,
    y2: 428.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8824_8115",
    x1: 242.521,
    x2: 233.153,
    y1: 407.413,
    y2: 402.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8824_8115",
    x1: 240.463,
    x2: 278.574,
    y1: 81.481,
    y2: 66.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#098A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#33F89A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#05BF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8824_8115",
    x1: 242.749,
    x2: 272.98,
    y1: 78.82,
    y2: 66.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8824_8115",
    x1: 242.746,
    x2: 272.977,
    y1: 78.737,
    y2: 66.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#16A460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FFC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8824_8115",
    x1: 243.372,
    x2: 272.903,
    y1: 80.195,
    y2: 66.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FF6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18CF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_8824_8115",
    x1: 260.564,
    x2: 274.221,
    y1: 72.95,
    y2: 81.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8824_8115",
    x1: 258.483,
    x2: 263.107,
    y1: 73.071,
    y2: 68.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8824_8115",
    x1: 254.615,
    x2: 259.413,
    y1: 78.248,
    y2: 73.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_8824_8115",
    x1: 256.9,
    x2: 258.149,
    y1: 71.645,
    y2: 72.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_8824_8115",
    x1: 252.35,
    x2: 254.135,
    y1: 76.238,
    y2: 77.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_8824_8115",
    x1: 580.758,
    x2: 630.501,
    y1: 358.484,
    y2: 428.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#098A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#33F89A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#05BF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_8824_8115",
    x1: 587.297,
    x2: 627.968,
    y1: 361.773,
    y2: 416.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_8824_8115",
    x1: 587.463,
    x2: 628.135,
    y1: 361.725,
    y2: 416.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#16A460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FFC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_8824_8115",
    x1: 584.827,
    x2: 628.322,
    y1: 363.726,
    y2: 416.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FF6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18CF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_8824_8115",
    x1: 608.147,
    x2: 597.825,
    y1: 394.882,
    y2: 426.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_8824_8115",
    x1: 606.854,
    x2: 619.145,
    y1: 390.73,
    y2: 397.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_8824_8115",
    x1: 594.427,
    x2: 607.179,
    y1: 385.507,
    y2: 392.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_8824_8115",
    x1: 608.943,
    x2: 607.234,
    y1: 386.807,
    y2: 389.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_8824_8115",
    x1: 597.356,
    x2: 594.941,
    y1: 379.909,
    y2: 384.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_8824_8115",
    x1: 1671.49,
    x2: 1742.34,
    y1: 106.615,
    y2: 106.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#098A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#33F89A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#05BF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_8824_8115",
    x1: 1676.86,
    x2: 1733.45,
    y1: 103.796,
    y2: 102.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_8824_8115",
    x1: 1676.91,
    x2: 1733.49,
    y1: 103.661,
    y2: 102.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#16A460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FFC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_8824_8115",
    x1: 1676.99,
    x2: 1733.45,
    y1: 106.403,
    y2: 102.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FF6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18CF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_8824_8115",
    x1: 1709.23,
    x2: 1725.76,
    y1: 105.718,
    y2: 128.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_8824_8115",
    x1: 1705.8,
    x2: 1716.37,
    y1: 104.586,
    y2: 99.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_8824_8115",
    x1: 1696.29,
    x2: 1707.25,
    y1: 110.44,
    y2: 105.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_8824_8115",
    x1: 1704.17,
    x2: 1705.44,
    y1: 101.286,
    y2: 103.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_8824_8115",
    x1: 1693.93,
    x2: 1695.76,
    y1: 105.766,
    y2: 109.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_8824_8115",
    x1: 1272.71,
    x2: 1182.62,
    y1: 135.84,
    y2: 12.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#098A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#33F89A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#05BF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_8824_8115",
    x1: 1260.95,
    x2: 1187.32,
    y1: 130.047,
    y2: 32.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_8824_8115",
    x1: 1260.66,
    x2: 1187.02,
    y1: 130.135,
    y2: 32.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#16A460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FFC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_8824_8115",
    x1: 1265.35,
    x2: 1186.69,
    y1: 126.513,
    y2: 32.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FF6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18CF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_8824_8115",
    x1: 1223.13,
    x2: 1241.15,
    y1: 71.069,
    y2: 13.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_8824_8115",
    x1: 1225.51,
    x2: 1203.4,
    y1: 78.484,
    y2: 66.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_8824_8115",
    x1: 1247.84,
    x2: 1224.9,
    y1: 87.654,
    y2: 75.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_8824_8115",
    x1: 1221.83,
    x2: 1224.84,
    y1: 85.54,
    y2: 79.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_8824_8115",
    x1: 1242.68,
    x2: 1246.94,
    y1: 97.721,
    y2: 89.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_8824_8115",
    x1: 1496.51,
    x2: 1464.81,
    y1: 517.352,
    y2: 456.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#098A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#33F89A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#05BF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_8824_8115",
    x1: 1491.67,
    x2: 1465.52,
    y1: 513.972,
    y2: 465.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_8824_8115",
    x1: 1491.53,
    x2: 1465.38,
    y1: 513.991,
    y2: 465.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#16A460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FFC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_8824_8115",
    x1: 1493.87,
    x2: 1465.21,
    y1: 512.697,
    y2: 465.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FF6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18CF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_8824_8115",
    x1: 1478.84,
    x2: 1490.76,
    y1: 485.131,
    y2: 460.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_8824_8115",
    x1: 1479.39,
    x2: 1470.37,
    y1: 488.595,
    y2: 481.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_8824_8115",
    x1: 1488.71,
    x2: 1479.35,
    y1: 494.199,
    y2: 487.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30DF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_8824_8115",
    x1: 1477.27,
    x2: 1478.99,
    y1: 491.487,
    y2: 489.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_8824_8115",
    x1: 1485.73,
    x2: 1488.17,
    y1: 498.331,
    y2: 495.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_8824_8115",
    x1: 1461.03,
    x2: 1463.23,
    y1: 272.278,
    y2: 279.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_8824_8115",
    x1: 1468.61,
    x2: 1475.65,
    y1: 269.983,
    y2: 267.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_8824_8115",
    x1: 1460.19,
    x2: 1462.64,
    y1: 260.133,
    y2: 259.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_8824_8115",
    x1: 1465.08,
    x2: 1467.54,
    y1: 258.618,
    y2: 257.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_8824_8115",
    x1: 556.586,
    x2: 553.768,
    y1: 59.084,
    y2: 65.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_8824_8115",
    x1: 563.815,
    x2: 570.545,
    y1: 62.308,
    y2: 65.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_8824_8115",
    x1: 563.903,
    x2: 566.242,
    y1: 49.354,
    y2: 50.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_8824_8115",
    x1: 568.592,
    x2: 570.941,
    y1: 51.411,
    y2: 52.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_8824_8115",
    x1: 25.953,
    x2: 34.892,
    y1: 273.151,
    y2: 283.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_8824_8115",
    x1: 37.372,
    x2: 47.992,
    y1: 263.483,
    y2: 254.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_8824_8115",
    x1: 15.382,
    x2: 19.073,
    y1: 252.709,
    y2: 249.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_8824_8115",
    x1: 22.73,
    x2: 26.439,
    y1: 246.411,
    y2: 243.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-129.571 212.133 162.093)scale(92.7146 138.521)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AF79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5F25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-168.849 487.21 785.614)scale(49.312 103.908)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-153.904 378.77 1152.614)scale(16.9116 124.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.3061 19.96956 -29.83583 12.40987 258.319 72.827)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AF79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5F25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(28.137 583.75 298.455)scale(11.5033 24.2393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(43.083 646.899 318.329)scale(3.94508 29.0196)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-36.24281 26.86725 -40.14136 -54.14904 607.265 390.274)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AF79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5F25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(104.172 555.695 540.812)scale(23.9954 50.562)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.00431 7.18931 -52.88384 -29.45532 1542.64 444.709)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(89.05 799.934 919.162)scale(37.3841 55.8542)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AF79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5F25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(12.84156 15.1805 -31.98752 27.05903 1827 -429.531)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(64.717 1491.258 1481.095)scale(6.81906 50.1603)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(64.50208 -48.64076 72.67238 96.3702 1224.78 79.307)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AF79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5F25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-76.298 416.96 185.107)scale(42.9678 90.5396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-61.353 -229.175 377.85)scale(14.7359 108.395)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(32.03775 -17.27248 25.80618 47.8664 1479.01 488.912)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AF79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5F25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.37427 -17.89904 37.71589 15.53867 963.365 622.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_8824_8115",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.02655 -5.2786 38.82891 29.61892 738.419 337.567)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8824_8115",
    width: 173.301,
    height: 182.037,
    x: 129.953,
    y: 354.92,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.997
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8824_8115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8824_8115",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8824_8115",
    width: 180.069,
    height: 177.837,
    x: 134.217,
    y: 329.718,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.997
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.121569 0 0 0 0 0.694118 0 0 0 0 0.423529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8824_8115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8824_8115",
    result: "shape"
  })))));
};
export default SvgAnimated;